export function getQuickReplyLabel(reply) {
    return typeof reply?.label === 'string' ? reply.label.trim() : '';
}

export function isQuickReplySelected(reply, followingUserMessage) {
    const label = getQuickReplyLabel(reply);
    const displayText = typeof followingUserMessage?.role === 'string'
        && followingUserMessage.role.toLowerCase() === 'user'
        && typeof followingUserMessage.displayText === 'string'
        ? followingUserMessage.displayText.trim()
        : '';

    return label !== '' && displayText !== '' && label.toLowerCase() === displayText.toLowerCase();
}

export function formatQuickReplies(quickReplies, followingUserMessage) {
    if (!Array.isArray(quickReplies)) return '';

    const lines = quickReplies
        .map(reply => {
            const label = getQuickReplyLabel(reply);
            if (!label) return null;
            return `- ${label}${isQuickReplySelected(reply, followingUserMessage) ? ' [Selected]' : ''}`;
        })
        .filter(Boolean);

    return lines.length > 0 ? `Quick replies:\n${lines.join('\n')}` : '';
}
